import { userApi, } from '@sellsen/generated-sources';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
const QUERY_KEYS = {
    all: ['user'],
    getCurrentUser: () => [...QUERY_KEYS.all, 'me'],
    getSellerBillingInfo: () => [...QUERY_KEYS.all, 'me', 'billing-info'],
};
export const USER_QUERY_KEYS = QUERY_KEYS;
export const useGetCurrentUserQuery = () => {
    return useQuery({
        queryKey: QUERY_KEYS.getCurrentUser(),
        queryFn: () => {
            return userApi.getCurrentUser();
        },
    });
};
/** Sipariş faturasındaki satıcı bilgisi ("Invoiced From"). Kayıt yoksa alanlar boş gelir. */
export const useGetSellerBillingInfoQuery = (enabled = true) => {
    return useQuery({
        queryKey: QUERY_KEYS.getSellerBillingInfo(),
        queryFn: () => userApi.getSellerBillingInfo(),
        enabled,
    });
};
export const useUpdateSellerBillingInfoMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (params) => userApi.updateSellerBillingInfo(params),
        onSuccess: (data) => {
            queryClient.setQueryData(QUERY_KEYS.getSellerBillingInfo(), data);
        },
    });
};
